/* eslint-disable import/prefer-default-export, no-shadow */
export const nextDay = new Date((new Date()).getTime() + (60 * 60 * 24 * 1000));
